<template>
    <dialogo-opciones-componente dialogo-titulo="Precio de venta"
                                 descripcion="Es el precio del material dispuesto a pie de obra">
        <template v-slot:titulo>
            PVP
            <v-tooltip bottom>
                <template v-slot:activator="{on}">
                    <v-icon v-on="on">mdi-information-outline</v-icon>
                </template>
                <span>Es el precio del material dispuesto a pie de obra, incluyendo el transporte.</span>
            </v-tooltip>

            <v-icon v-if="valido1 && valido2" color="green">mdi-check</v-icon>
            <v-icon v-if="!valido1 || !valido2" color="red">mdi-close</v-icon>
        </template>
        <template v-slot:opcion1>
            <input-precio-componente v-if="proyecto"
                                     v-model="valido1"
                                     :solucion-constructiva="proyecto.solucionesConstructivas[0]"
                                     :escenario="proyecto.escenario" :proyecto-id="proyecto.id">
            </input-precio-componente>
        </template>
        <template v-slot:opcion2>
            <input-precio-componente v-if="proyecto"
                                     v-model="valido2"
                                     :solucion-constructiva="proyecto.solucionesConstructivas[1]"
                                     :escenario="proyecto.escenario" :proyecto-id="proyecto.id">
            </input-precio-componente>
        </template>
    </dialogo-opciones-componente>
</template>

<script>
    import DialogoOpcionesComponente from "../Componentes/DialogoOpcionesComponente";
    import InputPrecioComponente from "./Componentes/InputPrecioComponente";

    export default {
        name: "PreciosComponente",
        model: {
            prop: 'correct',
            event: 'change'
        },
        props: {
            proyecto: {type: Object, required: true},
            correct: {type: Boolean, default: false}
        },
        components: {
            DialogoOpcionesComponente,
            InputPrecioComponente
        },
        watch: {
            valido1: {
                handler() {
                    this.emitirCorrecto();
                },
                deep: true
            },
            valido2: {
                handler() {
                    this.emitirCorrecto();
                },
                deep: true
            }
        },
        mounted() {
            this.emitirCorrecto();
        },
        data: function () {
            return {
                valido1: false,
                valido2: false
            }
        },
        methods: {
            emitirCorrecto() {
                this.$emit('change', this.valido1 && this.valido2);
            }
        }
    }
</script>

<style scoped>

</style>